import { StoredProcedureReportPopupFormController } from "./stored-procedure-report-popup-form.contrloller";
import { IMRBaseComponent } from "../../../../common/base";

import { USER_SESSION_SERVICE_NAME } from "../../../../../services/user-session";


//#region Asset Imports

import "./stored-procedure-report-popup-form.scss";
import * as TEMPLATE from "./stored-procedure-report-popup-form.tpl.html";

//#endregion

export const COMPONENT_NAME: string =
    "storedProcedureReportPopupForm";

export class StoredProcedureReportPopupFormComponent extends IMRBaseComponent {
  constructor() {
    super({
      controller: StoredProcedureReportPopupFormController,
      services: [
        USER_SESSION_SERVICE_NAME,
      ],
      template: TEMPLATE,
    });
  }
}
